export default __webpack_public_path__ + "416c7a1f3a88f0c2eca022431aaca8c0.png";